import React from 'react';

import CN from 'components/experiment/hooks/HooksPage.module.scss';
import Button from 'components/form/Button.component';
import Space from 'components/generic/Space.component';
import useTip from 'hooks/useTip.hook';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';

const L = logger('TextExample');

const TextExample = () => {
  const { val: isTextShown, inv: isTextHidden, tip: toggleText, yay: showText, nay: hideText } = useTip(false);

  L.debug('()', { isTextShown, isTextHidden });

  return (
    <div data-bem="TextExample" className={CN.col}>
      <div className={CN.row}>
        <Button onClick={toggleText} variant="primary" casing="dialog">
          toggle
        </Button>
        <Button onClick={showText}>show</Button>
        <Button onClick={hideText} variant="alert">
          hide
        </Button>
      </div>
      <p>
        value of isTextShown: {fromAnyToTrimmed(isTextShown)}
        <br />
        value of isTextHidden: {fromAnyToTrimmed(isTextHidden)}
      </p>

      {isTextShown && <Space>This text is visible</Space>}
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default TextExample;
